import React, { useContext } from 'react';
import Input from 'chameleon/ui-stack/ui/base/input';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import DynamicBuilderContext from '../context';

const labelClassName = 'ml-2 mb-2 text-14 font-medium';

const DynamicBuilderForm = (props) => {
  const { disableSubmit, onSubmit, children } = props;
  const { formData, onInputChange } = useContext(DynamicBuilderContext);
  const { placeholderTitle, userTitle, number, excludeInterval } = formData;

  return (
    <div className="p-8.4 border-t border-b border-gray-300">
      <fieldset>
        <div className="mb-6 w-1/2">
          <label htmlFor="assesment-title" className={labelClassName}>
            Title
          </label>
          <Input
            placeholder={placeholderTitle}
            className={{ 'input-field-invalid': false }}
            id="assesment-title"
            name="assesment-title"
            value={userTitle}
            onChange={onInputChange('userTitle')}
          />
        </div>
        {children}
        <div className="mb-6 w-1/2">
          <label htmlFor="assesment-title" className={labelClassName}>
            Number of Assessments
          </label>
          <Input
            defaultValue={1}
            step={1}
            min={0}
            type="number"
            className={{ 'input-field-invalid': false }}
            id="assesment-number"
            name="assesment-number"
            value={number}
            onChange={onInputChange('number')}
          />
        </div>
        <div>
          <div className="w-1/2">
            <label htmlFor="assesment-mcqs" className={labelClassName}>
              Exclude questions assigned to classes in the past "X" days
            </label>
            <Input
              label="Exclude questions assigned to classes in the past"
              placeholder="Exclude questions assigned to classes in the past"
              className={{ 'input-field-invalid': false, 'w-1/2': true }}
              id="assement-exclude-interval"
              name="assement-exclude-interval"
              type="number"
              step={1}
              min={0}
              value={excludeInterval}
              onChange={onInputChange('excludeInterval')}
            />
          </div>
        </div>
      </fieldset>
      <ButtonWithIcon
        isPrimary
        icon="add"
        disabled={disableSubmit}
        onClick={onSubmit}
      >
        Create
      </ButtonWithIcon>
    </div>
  );
};

export default DynamicBuilderForm;
